import { useQuery } from '@tanstack/react-query';
import { FilterModel } from '../common/model/ui/filter.model';
import { withFilterLookupOptions } from '../common/utils/services/list-filter-utils';
import { ScanFields, ScanMetaFields } from '../firebase/document-field.enums';
import LotsService from '../services/lots.service';
import { ScansService } from '../services/scans.service';

export function useScanListFilters(filters: FilterModel[]): FilterModel[] {
  const lotIds = useQuery({
    queryKey: ['admin-scans-lot-search-filters'],
    queryFn: () => LotsService.loadAllLotId(),
    retry: 0,
  });
  const devices = useQuery({
    queryKey: ['admin-scans-devices-search-filters'],
    queryFn: () => ScansService.loadAllScanDevices(),
    select: (data) => data.map(({ device_model }) => device_model),
    retry: 0,
  });
  const appVersions = useQuery({
    queryKey: ['admin-scans-app-versions-search-filters'],
    queryFn: () => ScansService.loadAllAppVersions(),
    select: (data) => data.map(({ app_version }) => app_version),
    retry: 0,
  });

  return withFilterLookupOptions(filters, {
    [ScanFields.lot_id]: { query: lotIds },
    [ScanMetaFields.device_model]: { query: devices },
    [ScanMetaFields.app_version]: { query: appVersions },
  });
}
